import React from 'react';
import pulseSvg from '../images/pulse.svg';
import '../styles/pulse.scss';

const Pulse = () => {
  return <div className='pulse' />
}

export default Pulse;
